// extracted by mini-css-extract-plugin
module.exports =  {"leftAlign":"E_BOmGIu99uAinI6NiNg"};